import { Endpoint } from '@/types/api.type.ts';

export const userEndpoints: Endpoint[] = [
    {
        name: 'getUsers',
        method: 'get',
        path: '/users',
    },
    {
        name: 'getUser',
        method: 'get',
        path: '/users/:id',
    },
    {
        name: 'createUser',
        method: 'post',
        path: '/users',
    },
    {
        name: 'updateUser',
        method: 'patch',
        path: '/users/:id',
    },
    {
        name: 'activateUser',
        method: 'patch',
        path: '/users/:id/activate',
    },
    {
        name: 'deactivateUser',
        method: 'patch',
        path: '/users/:id/deactivate',
    },
    {
        name: 'approveUser',
        method: 'patch',
        path: '/users/:id/approve',
    },
    {
        name: 'rejectUser',
        method: 'patch',
        path: '/users/:id/reject',
    },
    {
        name: 'getUserDealers',
        method: 'get',
        path: '/users/:id/dealers',
    },
    {
        name: 'changeCurrentDealer',
        method: 'patch',
        path: '/users/change-current-dealer/:id',
    },
    {
        name: 'getUserNotificationSettings',
        method: 'get',
        path: '/users/notification-settings',
    },
    {
        name: 'updateUserNotificationSettings',
        method: 'post',
        path: '/users/notification-settings',
    },
];
